import App from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"
import * as Preact from "preact"

import YesButtonImage from "@frog/source/assets/images/cryptid-tactics/UI/UI_btn_confirm.png"
import YesButtonImageHover from "@frog/source/assets/images/cryptid-tactics/UI/UI_btn_confirm_hover.png"
import NoButtonImage from "@frog/source/assets/images/cryptid-tactics/UI/UI_btn_cancel.png"
import NoButtonImageHover from "@frog/source/assets/images/cryptid-tactics/UI/UI_btn_cancel_hover.png"

import "@frog/source/views/app/components/MiniMenu.view.less"

export default class MiniMenu {
    render() {
        if(Navigation.state.minimenu != undefined) {
            return (
                <div class="MiniMenu" onClick={this.onClickOutOfModal}>
                    <div class="Modal" onClick={this.onClickModal}>
                        <div class="BackgroundContainer">
                            <div class="BackgroundRect"></div>
                            <div class="BackgroundRect"></div>
                            <div class="BackgroundRect"></div>
                        </div>
                        <div class="Prompt">Quit?</div>
                        <div class="Options">
                            <div class="Yes" onClick={this.onClickQuitButton}/>
                            <div class="No" onClick={this.onClickOutOfModal}/>
                        </div>
                    </div>
                </div>
            )
        }
    }
    onClickModal(event) {
        event.preventDefault()
        event.stopPropagation()
    }
    onClickOutOfModal(event) {
        Navigation.state.minimenu = undefined
    }
    onClickQuitButton(event) {
        console.log("YEAH")
        Navigation.state.minimenu = undefined
        Navigation.go("/game")
    }
}
